<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed)
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') メンバーアクティビティ
  v-container(fluid)
    v-row(align='center', justify='center')
      v-row(class="timerow")
      v-list
        v-list-item
          v-row()
            span
              v-btn(@click='movePrev()') {{'前週'}}
              v-btn(@click='moveNext()') {{'翌週'}}
              v-btn(@click='showFilter = !showFilter', :color='(selectedTagId || selectedProjectId) ? "primary" : ""', class='ml-2')
                v-icon(left) mdi-filter
                | フィルター
              v-btn(v-if='selectedTagId || selectedProjectId', @click='clearFilters()', text, small, class='ml-1') クリア
      v-row(v-if='showFilter', class='pa-3')
        v-col(cols='12')
          span(class='caption font-weight-medium mr-2') タグ:
          v-chip(class='mr-1 mb-1', :color='!selectedTagId ? "primary" : ""', @click='selectedTagId = ""', small) 全員
          v-chip(v-for='tag in memberTags', :key='tag.memberTagId', class='mr-1 mb-1', :color='selectedTagId === tag.memberTagId ? "primary" : ""', @click='toggleTag(tag.memberTagId)', small) {{tag.name}}
        v-col(cols='12')
          span(class='caption font-weight-medium mr-2') プロジェクト:
          v-select(:items='projectOptions', v-model='selectedProjectId', dense, clearable, label='プロジェクトで絞り込み', style='max-width:400px;display:inline-block;', item-text='name', item-value='projectId', hide-details)
      v-row
        table(class='member-activity-table ma-3')
          tr
            th 名前
            th(v-for="item in firstCalendars", :key='item.date') {{item.dateDisp}}
          tr(v-for='item in filteredMembers', :key='item.displayName')
            td {{item.displayName}}    
            td(v-for="(cal, index) in firstCalendars", :key='cal.date')
              p(class='ma-0', v-if="item.dates[index].ignoreTimesheet==false")
                v-btn(:color="getButtonColor(item.dates[index])", @click='showDetail(item.dates[index])', small) {{item.dates[index].workTypeName}}
              span(class='member-plan-cell') {{item.dates[index].plan}}
    v-dialog(v-model='dialogWorkType', max-width='400')
      v-card
        v-card-title Koos Workspace
        v-card-text 勤務区分を変更します。コメントを記入お願いします。 
        v-card-text()
          v-card(min-width='200', width='200', flat, class='timecell ml-2')
            v-select(:items='pcDetail.tenantWorkTypes', item-text="name", item-value='tenantWorkTypeId', v-model='pcDetail.detail.tenantWorkTypeIdAM', dense, width='80', label='午前')
          v-card(min-width='200', width='200', flat, class='timecell ml-2')
            v-select(:items='pcDetail.tenantWorkTypes', item-text="name", item-value='tenantWorkTypeId', v-model='pcDetail.detail.tenantWorkTypeIdPM', dense, width='80', label='午後')
        v-card-text(class='approve-title') 承認履歴
        v-card-text  
          v-row(v-for="(item, index) in pcDetail.detail.approvals", :key="index", class='status-message-row')
            span {{item.posted}} {{item.status}} [{{item.workTypeName}}] {{item.changedDisplayName}} {{item.changedComment}}
        v-card-text
          v-text-field(v-model='pcDetail.detail.plan', label='その日のメンバー予定') 
          v-text-field(v-model='pcDetail.comment', label='コメント') 
        v-card-actions
          v-spacer
          v-btn(text, @click='cancelRequest') キャンセル
          v-btn(text, @click='confirmRequest') OK
</template>

<script>
import basic from '@/components/mixins/basic'
import moment from "moment-timezone";
moment.locale('ja')

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    firstCalendars() {
      return this.members.length>0 ? this.members[0].dates : []
    },
    filteredMembers() {
      let result = this.members
      if (this.selectedTagId) {
        const tag = this.memberTags.find(t => t.memberTagId === this.selectedTagId)
        if (tag && tag.assignedUsers) {
          result = result.filter(m => tag.assignedUsers.includes(m.displayName))
        }
      }
      if (this.selectedProjectId) {
        const project = this.projectAssigns.find(p => p.projectId === this.selectedProjectId)
        if (project && project.assigns) {
          const assignedNames = project.assigns.filter(a => a.enabled !== false).map(a => a.displayName)
          result = result.filter(m => assignedNames.includes(m.displayName))
        }
      }
      return result
    },
    projectOptions() {
      return this.projectAssigns.filter(p => p.assigns && p.assigns.length > 0)
    }
  },
  data() {
    return {
      members: [],
      targetDate: null,
      startDay: null,
      endDay: null,
      pcDetail: {detail: {}, tenantWorkTypes: [], comment:''},
      dialogWorkType: false,
      memberTags: [],
      projectAssigns: [],
      selectedTagId: '',
      selectedProjectId: '',
      showFilter: false,
    }
  },
  mounted() {
    this.yearMonthDate = moment([moment().year(), moment().month(), 1])
  },
  methods: {
    async masterReady () {
      if (!this.$store.getters['Login/isAdmin']) {
        this.$router.push(this.site.deployFolder + "/")
      }
      this.workTypes = await this.$store.dispatch('Calendar/getWorkTypes')
      this.memberTags = await this.$store.dispatch('MemberTags/listAll', '') || []
      this.projectAssigns = await this.$store.dispatch('ProjectAssign/listAll') || []
      this.targetDate = moment()
      await this.search()
    },
    toggleTag(tagId) {
      this.selectedTagId = this.selectedTagId === tagId ? '' : tagId
    },
    clearFilters() {
      this.selectedTagId = ''
      this.selectedProjectId = ''
    },
    async search () {
      this.startDay = this.targetDate.clone().add(-1 * this.targetDate.isoWeekday() + 1, 'd');
      this.endDay = this.targetDate.clone().add(7 - this.targetDate.isoWeekday(), 'd');
      this.members = await this.$store.dispatch("Calendar/membersActivity", {startDay: this.startDay.format('YYYY-MM-DD'), endDay: this.endDay.format('YYYY-MM-DD')});
    },
    movePrev() {
      this.targetDate = this.targetDate.clone().add(-7, 'd')
      this.search()
    },
    moveNext() {
      this.targetDate = this.targetDate.clone().add(7, 'd')
      this.search()
    },
    getButtonColor(item) {
      if (item.offLevel == 0)
      {
        return ''
      }
      if (item.offLevel == 1)
      {
        return '#FFD'
      }
      if (item.offLevel == 2)
      {
        return '#FCF'
      }
    },
    async showDetail (item) {
      this.pcDetail = await this.$store.dispatch("Calendar/personalCalendarDetail", item.personalCalendarId)
      this.pcDetail.comment = ''
      this.dialogWorkType = true
    },
    async cancelRequest () {
      this.dialogWorkType = false
    },
    async confirmRequest () {
      this.dialogWorkType = false
      this.requestParam = { personalCalendarId: this.pcDetail.detail.personalCalendarId, param: 'change', value: '', plan: this.pcDetail.detail.plan , comment: this.pcDetail.comment, tenantWorkTypeIdAM: this.pcDetail.detail.tenantWorkTypeIdAM, tenantWorkTypeIdPM: this.pcDetail.detail.tenantWorkTypeIdPM, isOffDay: this.pcDetail.detail.isOffDay }
      await this.$store.dispatch("Calendar/updatePersonal", this.requestParam); 
      this.dialogWorkType = false;
      this.dispSuccess('勤務変更を変更しました。必要でしたら、メンバーにもお伝えください。')
      this.search()
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    }
  }
};
</script>

<style>
.timerow {
  border-bottom-style: solid;
  border-bottom-width: 1pt;
  border-bottom-color:lightgray;
}
.timecell {
  background-color: transparent !important;
}
.odd {
  background-color: rgb(232, 232, 232);
}
.user-table td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.user-image {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.5px;
  border-color: lightgray;
}
.inactive {
  -webkit-filter: grayscale() opacity(.5);
  filter: grayscale() opacity(.5);
}
/* .timeinput fieldset {
  border-color: rgb(210, 210, 210) !important;
  height: 41px !important;
  background-color: white !important;
}
*/
.timesheet-table {
  width: 100%;
}

label.v-label {
  font-size: .8em !important;
}
.centered-input input {
  text-align: center
}
.member-plan-cell {
  font-size: .7em;
}
.member-activity-table {
  padding:0em 2em;
  border-collapse: collapse;
  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #ccc;
  border-top-style: solid !important;
  border-top-width: 1px;
  border-top-color: #ccc;
}
.member-activity-table td {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;

}
.member-activity-table th {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;

}
.approve-title {
  font-weight: bold;
  color: black !important;
}
</style>